module.exports = __webpack_public_path__ + "static/media/glass_logo_32.b8029828.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/glass_logo_32.png
 ** module id = 220
 ** module chunks = 0
 **/